import { render, staticRenderFns } from "./AdminBaseReviewJobs.vue?vue&type=template&id=285b9378"
import script from "./AdminBaseReviewJobs.vue?vue&type=script&lang=js"
export * from "./AdminBaseReviewJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports